const camelToSnakeCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const snakeToCamelCase = (str) =>
  str
    .toLowerCase()
    .replace(/[-_][a-z]/g, (group) => group.slice(-1).toUpperCase());

export const objectToSnakeCase = (obj) =>
  Object.keys(obj || {}).reduce(
    (result, key) => ({ ...result, [camelToSnakeCase(key)]: obj[key] }),
    {}
  );

export const objectToCamelCase = (obj) =>
  Object.keys(obj || {}).reduce(
    (result, key) => ({ ...result, [snakeToCamelCase(key)]: obj[key] }),
    {}
  );

export const objectRemoveSpaceInKeys = (obj) => {
  let newName;
  // Loop through the property names
  for (let name in obj) {
    // Get the name without spaces
    newName = name.replace(/ /g, "");
    // If that's different...
    if (newName != name) {
      // Create the new property
      obj[newName] = obj[name];
      // Delete the old one
      delete obj[name];
    }
  }
  return obj;
};

export const isNumeric = (str) => {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  );
};

/* options
  fixedDecimals: example value 4, decimal "00" would be "0000", 4.00 => 4.0000
  minFixedDecimals: example value 2, decimal "0" would be "00" , 4.5 => 4.50
*/
export const stringAsNumber = (
  original,
  language,
  options = { fixedDecimals: 0, minFixedDecimals: 0 }
) => {
  let str = "";

  const { fixedDecimals, minFixedDecimals } = options;

  if (fixedDecimals) {
    str = roundToDecimals(original, fixedDecimals).toString();
  } else {
    str = original;
  }

  const separator = language === "es" ? "." : ",";

  const decimalSeparator = language === "es" ? "," : ".";

  if (str || str === "0" || str === 0) {
    const [integer = "", decimal = ""] = str.toString().split(".");

    const integerPart = integer
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, separator);

    let decimalPart = decimal;

    if (fixedDecimals || minFixedDecimals) {
      decimalPart = decimalPart.padEnd(fixedDecimals || minFixedDecimals, "0");
    }

    return decimalPart
      ? integerPart + decimalSeparator + decimalPart
      : integerPart;
  }

  return "";
};

export const formattedDate = (dateAsString, language) => {
  if (!!dateAsString) {
    const date =
      new Date(dateAsString + "T00:00:00").toLocaleDateString(language) || "";
    return date.replace(/\//g, "-");
  }
  return "";
};

export const roundToTwoDecimals = (number) => roundToDecimals(number, 2);

export const roundToDecimals = (number, decimal) => {
  if (!number) return 0;

  let result = "";

  try {
    const factor = 10 ** decimal;

    result = Math.round((parseFloat(number) + Number.EPSILON) * factor) / factor;
  } catch (e) {
    console.log(e);
  }

  return result;
};
